import styled from 'styled-components';

import { ButtonWithLoader } from '../../components/ui-helpers/';


export const CommentInfoWrap = styled.div`
  margin-top: 18px;
`;

export const ButtonWrap = styled.div`
  margin-top: 20px;
  text-align: center;

  ${ButtonWithLoader} {
    height: 40px;
    max-width: 160px;
    border-radius: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/modals/comments-modal/styles.js